import { FormInputProps } from "@components/WAChatbutton/WAform/WidgetForm";
import { useEffect, useState } from "react";
import { UseFormReturn, useWatch } from "react-hook-form";
import ConversationContainer, { WidgetConfig } from "./Conversation";
import "./WAPreview.module.css";

interface WAWidgetPreviewProps {
    control: UseFormReturn<FormInputProps>["control"];
}

const WhatsappWidgetPreview: React.FC<WAWidgetPreviewProps> = ({ control }) => {
    const data = useWatch<FormInputProps>({ control });

    const [mappedData, setMappedData] = useState<WidgetConfig>();
    useEffect(() => {
        if (!data) {
            return;
        }
        const {
            brandName,
            statusTag,
            wanumber,
            welcomeText,
            triggerMsg,
            question,
            buttonPosition,
            logo,
            options,
            widgetStyle,
            customQuestion,
            startChatBtnTxt,
            widgetPositionMarginX,
            widgetPositionMarginY,
        } = data as FormInputProps;

        const config: WidgetConfig = {
            waId: wanumber,
            siteName: brandName || "Gallabox",
            siteTag: statusTag || "Usually reply in 4 minutes",
            siteLogo: logo,
            widgetPosition: buttonPosition !== "RIGHT" ? "LEFT" : "RIGHT",
            widgetStyle: widgetStyle,
            triggerMessage: triggerMsg,
            welcomeMessage: welcomeText || "Welcome to Gallabox! Convert conversations to actions...",
            messageText: question || "I am looking for:",
            replyOptions: options?.map((o: { content: string }) => o.content) || [],
            customQuestion: customQuestion || "Just visited your website! Would like to know more about it!",
            startChatBtnTxt: startChatBtnTxt || "Chat with us",
            widgetPositionMarginX: widgetPositionMarginX,
            widgetPositionMarginY: widgetPositionMarginY,
        };
        setMappedData(config);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [JSON.stringify(data)]);

    return (
        <div className="max-w-md">
            <div className="main-container">
                <ConversationContainer data={mappedData} />
            </div>
        </div>
    );
};

export default WhatsappWidgetPreview;
